import { getContrast } from 'polished';
import { ThemeWebColors } from 'styled-components/macro';
import defaultTheme from 'theme/defaultTheme';

export const isLowContrast = (color: string, bgColor: string = '#fff'): boolean => {
    try {
        const contrast = getContrast(color, bgColor);
        return contrast < 1.25;
    } catch (error) {
        return true; // We should not send in color strings that break here but falls back to showing border in case of strange or broken color string.
    }
};

export const isThemeColor = (color: string | PropertyKey): color is keyof ThemeWebColors => {
    return color in defaultTheme.webColors;
};
